import { PriceCurrencyType } from '../graphql/queries/getPrice.query'

export class NumberUtils {
  static numberWithComma = (value: number) => {
    // Check if the number has decimals
    const hasDecimal = value % 1 !== 0

    return hasDecimal
      ? value
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      : value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  static mapCurrencyText = (currency: PriceCurrencyType, priceText: string) => {
    if (currency === 'THB') {
      return `฿${priceText}`
    }

    if (currency === 'PERCENT') {
      return `${priceText}%`
    }

    return `${priceText} ${currency}`
  }
}
